import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IAIAgentTemplate, IAIAgentTemplateFormData } from '../../extViewmodels/sdk/models/AI';

export function useCreateAIAgentTemplateMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IAIAgentTemplate) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({
			data,
			impersonationContext,
		}: {
			data: IAIAgentTemplateFormData;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<IAIAgentTemplate>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'aiagenttemplate' }),
				'POST',
				data
			);
		},
		onError,
		onSuccess,
	});
}
